import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FONT_FAMILY } from "../../common/sharedFunctions";

export default function HomeFooter() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const links = [["/", t("home")], ["/about-us", t("about_us")], ["/contact-us", t("contact_us")], ["/privacy-policy", t("privacy_policy")], ["/term-condition", t("term_condition")]];
  return (
    <Box component="footer" sx={{ bgcolor: "#071022", color: "white", px: { xs: 2.5, md: 6 }, pt: 7, pb: 3 }}>
      <Box sx={{ maxWidth: 1200, mx: "auto" }}>
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, alignItems: { md: "center" }, justifyContent: "space-between", gap: 4, pb: 5 }}>
          <Box><Typography sx={{ fontFamily: FONT_FAMILY, fontSize: 28, fontWeight: 850 }}>QC<span style={{ color: "#FFD43B" }}>.Taxi</span></Typography><Typography sx={{ mt: 1, color: "rgba(255,255,255,.58)", fontFamily: FONT_FAMILY, fontSize: 14 }}>{t("landing_footer_tagline")}</Typography></Box>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: .5 }}>{links.map(([path, label]) => <Button key={path} onClick={() => navigate(path)} sx={{ color: "rgba(255,255,255,.76)", fontFamily: FONT_FAMILY, fontWeight: 650, fontSize: 13, textTransform: "none", borderRadius: 2, "&:hover": { color: "white", bgcolor: "rgba(255,255,255,.06)" } }}>{label}</Button>)}</Box>
        </Box>
        <Box sx={{ borderTop: "1px solid rgba(255,255,255,.1)", pt: 3 }}><Typography sx={{ color: "rgba(255,255,255,.44)", fontFamily: FONT_FAMILY, fontSize: 12 }}>&copy; {new Date().getFullYear()} QC.Taxi. {t("landing_rights")}</Typography></Box>
      </Box>
    </Box>
  );
}
